var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "b-modal",
    {
      ref: "modal",
      staticClass: "scan-menu-full-screen-modal",
      attrs: {
        id: "scan-menu-modal",
        "header-class": "scan-menu-modal-header",
        "cancel-title": _vm.$t("Cancel"),
        "ok-title": _vm.$t("scan.menu.modal.try.match"),
        centered: "",
        "ok-variant": "primary"
      },
      on: { ok: _vm.onValidateClicked },
      scopedSlots: _vm._u([
        {
          key: "modal-header",
          fn: function(ref) {
            var close = ref.close
            return [
              _c(
                "div",
                { staticClass: "scan-menu-modal-header-content step4 w-100" },
                [
                  _c("img", {
                    staticClass: "scan-menu-modal-img",
                    attrs: {
                      src: require("@/assets/images/b122/img-watcher-right.png")
                    }
                  }),
                  _vm._v(" "),
                  _c("div", { staticClass: "scan-menu-container h-100" }, [
                    _c("h1", {
                      staticClass: "page-title ml-4 scan-menu-modal-subtitle",
                      domProps: {
                        innerHTML: _vm._s(_vm.$t("scan.menu.modal.title"))
                      }
                    })
                  ])
                ]
              )
            ]
          }
        }
      ])
    },
    [
      _c(
        "b-form-group",
        {
          staticClass: "small-text",
          attrs: {
            label: _vm.$t("scan.menu.modal.type.scan"),
            "label-for": "scan-type-input"
          }
        },
        [
          _c(
            "b-form-select",
            {
              attrs: { id: "scan-type-input", required: "" },
              on: { change: _vm.onScanTypeChange },
              model: {
                value: _vm.scanType,
                callback: function($$v) {
                  _vm.scanType = $$v
                },
                expression: "scanType"
              }
            },
            _vm._l(_vm.scanTypes, function(type) {
              return _c("option", { domProps: { value: type.value } }, [
                _vm._v("\n        " + _vm._s(_vm.$t(type.text)) + "\n      ")
              ])
            }),
            0
          )
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "div",
        {
          staticClass: "d-flex justify-content-between align-items-center mb-2"
        },
        [
          _c(
            "label",
            { staticClass: "mr-3", on: { click: _vm.onPositionToggled } },
            [
              _vm._v(
                "\n      " +
                  _vm._s(_vm.$t("scan.menu.modal.activate.geoloc")) +
                  "\n    "
              )
            ]
          ),
          _vm._v(" "),
          _c("b-form-checkbox", {
            attrs: { size: "lg", checked: _vm.enabledPosition, switch: "" }
          })
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "b-form-group",
        {
          staticClass: "small-text",
          attrs: {
            label: _vm.getInputLabel + "*",
            "invalid-feedback": _vm.identifierInput.invalidFeedback,
            "label-for": "identifier-input"
          }
        },
        [
          _c("b-form-input", {
            attrs: {
              state: _vm.identifierInput.state,
              id: "identifier-input",
              formatter: _vm.getInputFormatter,
              required: ""
            },
            on: {
              change: function($event) {
                _vm.identifierInput.state = null
              }
            },
            model: {
              value: _vm.identifierInput.value,
              callback: function($$v) {
                _vm.$set(_vm.identifierInput, "value", $$v)
              },
              expression: "identifierInput.value"
            }
          })
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-776df5fd", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-776df5fd","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/match/ScanMenuModal.vue
// module id = PjDf
// module chunks = 0